import React from 'react';
import { Button, Flex, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  icon: React.ReactNode;
  title?: string;
  subtitle?: string;
  button: {
    label?: string;
    onClick?: () => void;
    variant: 'primary' | 'secondary';
    disabled?: boolean;
    loading?: boolean;
  };
};

export const ActionRow = ({ icon, title, subtitle, button }: Props) => {
  return (
    <Flex
      align="center"
      justify="space-between"
      px="sm"
      py="xs"
      bg="gray.0"
      style={{
        borderRadius: 12,
      }}
    >
      <Flex align="center" gap="xs">
        {icon}
        <Flex direction="column" justify={subtitle ? undefined : 'center'}>
          <Text size="md" fw={FONT_WEIGHTS.semibold} c="gray.10">
            {title}
          </Text>
          {subtitle && (
            <Text size="xs" fw={FONT_WEIGHTS.medium} c="gray.6">
              {subtitle}
            </Text>
          )}
        </Flex>
      </Flex>

      <AccountActionButton
        label={button.label}
        onClick={button.onClick}
        variant={button.variant}
        disabled={button.disabled}
        isLoading={button.loading}
      />
    </Flex>
  );
};

function AccountActionButton({
  label,
  onClick,
  variant,
  isLoading = false,
  disabled = false,
}: {
  label?: string;
  onClick?: () => void;
  variant: 'primary' | 'secondary';
  isLoading?: boolean;
  disabled?: boolean;
}) {
  return (
    <Button
      variant={variant}
      onClick={onClick}
      disabled={disabled}
      loading={isLoading}
      loaderProps={variant === 'secondary' ? { color: 'gray.9' } : undefined}
    >
      {label}
    </Button>
  );
}
